#_{:clj-kondo/ignore #?(:clj [:unused-namespace] :cljs [])}
(ns manatee.keyboard.handlers
  (:require
   #?(:cljs [rothko.audio.wave-player.component :as wave-player])
   [clojure.set :refer [map-invert]]
   [manatee.annotation.app-db :as annotation-db]
   [manatee.models.segment :as segment-model]
   [medley.core :refer [map-vals remove-vals]]
   [re-frame.core :as rf]))

(def key-code->key
  "These are to be used with the `onKeyDown` or `onKeyUp` events not
  `onKeypress` and need to be run through
  goog.events.KeyCodes.normalizeKeyCode"

  {0 {:key "Unidentified"}
   3 {:name :break :type :control}
   ;;  backspace / MacOS delete
   8 {:name :backspace :type :edit}
   9 {:name :tab :type :whitespace}
   12 {:name :clear :type :control}
   13 {:name :enter :type :whitespace}
   16 {:name :shift :type :modifier}
   17 {:name :ctrl :type :modifier}
   18 {:name :alt :type :modifier}
   19 {:name :pause-break}
   20 {:name :caps-lock}
   21 {:description "hangul"}
   25 {:description "hanja"}
   27 {:name :escape :type :control}
   28 {:description "conversion"}
   29 {:description "non-conversion"}
   32 {:name :space :type :whitespace}
   33 {:name :page-up :type :control}
   34 {:name :page-down :type :control}
   35 {:name :end :type :control}
   36 {:name :home :type :control}
   37 {:name :left-arrow :type :control}
   38 {:name :up-arrow :type :control}
   39 {:name :right-arrow :type :control}
   40 {:name :down-arrow :type :control}
   41 {:description "select"}
   42 {:description "print"}
   43 {:description "execute"}
   44 {:description "Print Screen"}
   45 {:description :insert}
   46 {:name :delete :type :edit}
   47 {:description "help"}
   48 {:name "0" :type :number}
   49 {:name "1" :type :number}
   50 {:name "2" :type :number}
   51 {:name "3" :type :number}
   52 {:name "4" :type :number}
   53 {:name "5" :type :number}
   54 {:name "6" :type :number}
   55 {:name "7" :type :number}
   56 {:name "8" :type :number}
   57 {:name "9" :type :number}
   ;; Does not seem to be used in MacOS at least
   58 {:name :colon :type :punctuation}
   ;; semicolon in Firefox, some sites say it's 'equals'
   59 {:name :semicolon :type :punctuation}
   60 {:description "<" :type :punctuation}
   ;; equals (firefox)
   61 {:name :equals :type :punctuation}
   63 {:description "ß"}
   64 {:name :firefox-at :type :punctuation}
   65 {:name "a" :type :letter}
   66 {:name "b" :type :letter}
   67 {:name "c" :type :letter}
   68 {:name "d" :type :letter}
   69 {:name "e" :type :letter}
   70 {:name "f" :type :letter}
   71 {:name "g" :type :letter}
   72 {:name "h" :type :letter}
   73 {:name "i" :type :letter}
   74 {:name "j" :type :letter}
   75 {:name "k" :type :letter}
   76 {:name "l" :type :letter}
   77 {:name "m" :type :letter}
   78 {:name "n" :type :letter}
   79 {:name "o" :type :letter}
   80 {:name "p" :type :letter}
   81 {:name "q" :type :letter}
   82 {:name "r" :type :letter}
   83 {:name "s" :type :letter}
   84 {:name "t" :type :letter}
   85 {:name "u" :type :letter}
   86 {:name "v" :type :letter}
   87 {:name "w" :type :letter}
   88 {:name "x" :type :letter}
   89 {:name "y" :type :letter}
   90 {:name "z" :type :letter}
   91 {:description "Windows Key / Left ⌘ / Chromebook Search key"}
   92 {:description "right window key"}
   93 {:description "Windows Menu / Right ⌘"}
   95 {:description "sleep"}
   96 {:description "numpad 0"}
   97 {:description "numpad 1"}
   98 {:description "numpad 2"}
   99 {:description "numpad 3"}
   100 {:description "numpad 4"}
   101 {:description "numpad 5"}
   102 {:description "numpad 6"}
   103 {:description "numpad 7"}
   104 {:description "numpad 8"}
   105 {:description "numpad 9"}
   106 {:description "multiply"}
   107 {:description "add"}
   108 {:description "numpad period (firefox)"}
   109 {:description "subtract"}
   110 {:name :decimal-point :type :punctuation}
   111 {:description "divide"}
   112 {:description "f1"}
   113 {:description "f2"}
   114 {:description "f3"}
   115 {:description "f4"}
   116 {:description "f5"}
   117 {:description "f6"}
   118 {:description "f7"}
   119 {:description "f8"}
   120 {:description "f9"}
   121 {:description "f10"}
   122 {:description "f11"}
   123 {:description "f12"}
   124 {:description "f13"}
   125 {:description "f14"}
   126 {:description "f15"}
   127 {:description "f16"}
   128 {:description "f17"}
   129 {:description "f18"}
   130 {:description "f19"}
   131 {:description "f20"}
   132 {:description "f21"}
   133 {:description "f22"}
   134 {:description "f23"}
   135 {:description "f24"}
   144 {:description "num lock"}
   145 {:description "scroll lock"}
   151 {:description "airplane mode"}
   160 {:name :caret :type :punctuation}
   161 {:name :exclamation-mark :type :punctuation}
   162 {:description "؛ (arabic semicolon)" :type :punctuation}
   163 {:name :pound-sign :type :punctuation}
   164 {:name :dollar :type :punctuation}
   165 {:description "ù"}
   166 {:description "page backward"}
   167 {:description "page forward"}
   168 {:description "refresh"}
   169 {:description "closing paren (AZERTY)"}
   170 {:name :asterisk :type :punctuation}
   ;; "~ + * key"
   171 {:name :unkown-key :type :punctuation}
   172 {:description "home key"}
   173 {:description "minus (firefox) mute/unmute"}
   174 {:description "decrease volume level"}
   175 {:description "increase volume level"}
   176 {:description "next"}
   177 {:description "previous"}
   178 {:description "stop"}
   179 {:description "play/pause"}
   180 {:description "e-mail"}
   181 {:description "mute/unmute (firefox)"}
   182 {:description "decrease volume level (firefox)"}
   183 {:description "increase volume level (firefox)"}
   186 {:name :semi-colon :type :punctuation}
   187 {:name :equals :type :punctuation}
   188 {:name :comma :type :punctuation}
   189 {:name :dash :type :punctuation}
   190 {:name :period :type :punctuation}
   191 {:name :forward-slash :type :punctuation}
   192 {:name :grave-accent :type :punctuation}
   193 {:name :question-mark :type :punctuation}
   194 {:description "numpad period (chrome)"}
   219 {:name :open-bracket :type :punctuation}
   220 {:name :backslash :type :punctuation}
   221 {:name :close-bracket :type :punctuation}
   222 {:name "'" :type :punctuation}
   223 {:description "`" :type :punctuation}
   224 {:description "left or right ⌘ key (firefox)"}
   225 {:description "altgr"}
   226 {:name :left-backslash :type :punctuation}
   230 {:description "GNOME Compose Key"}
   231 {:description "ç"}
   233 {:description "XF86Forward"}
   234 {:description "XF86Back"}
   235 {:description "non-conversion"}
   240 {:description "alphanumeric"}
   242 {:description "hiragana/katakana"}
   243 {:description "half-width/full-width"}
   244 {:description "kanji"}
   251 {:description "unlock trackpad (Chrome/Edge)"}
   255 {:description "toggle touchpad"}})

(def key->key-code
  (->> key-code->key
       (map-vals :name)
       (remove-vals nil?)
       (map-invert)))

(def keybindings
  {:annotation
   (concat [{:event :annotation/enter-pressed
             :key :enter}]
           (for [i (range 10)]
             {:event :annotation/add-score-keys
              :key (str i)}))
   :wave-player [{:event :annotation/play-pause-player
                  :mod :ctrlKey
                  :key "p"}
                 {:event :wave-player/scrub-back
                  :mod :ctrlKey
                  :key :left-arrow}
                 {:event :wave-player/scrub-forward
                  :mod :ctrlKey
                  :key :right-arrow}
                 {:event :wave-player/play-prev-segment
                  :mod :ctrlKey
                  :key :up-arrow}
                 {:event :wave-player/play-next-segment
                  :mod :ctrlKey
                  :key :down-arrow}
                 {:event :wave-player/play-current-segment
                  :mod :ctrlKey
                  :key "k"}
                 {:event :wave-player/play-last-sec-of-segment
                  :mod :ctrlKey
                  :key "l"}
                 {:event :wave-player/go-back-to-end-of-prev-segment
                  :mod :ctrlKey
                  :key "b"}]})

(defn make-keydown-rules
  [bindings]
  (let [all-bindings (->> (select-keys keybindings bindings)
                          (vals)
                          (apply concat))
        keycode-map (map #(update % :key key->key-code) all-bindings)
        event-keys (for [{:keys [event key mod]} keycode-map]
                     [[event]
                      (cond-> {:keyCode key}
                        mod (assoc mod true)
                        true vector)])
        prevent-default-keys (for [{:keys [key mod]} keycode-map]
                               {:keyCode key
                                mod true})]
    {:event-keys event-keys
     :clear-keys []
     :always-listen-keys []
     :prevent-default-keys prevent-default-keys}))

(rf/reg-event-fx
 ::init-keyboard
 (fn init-keyboard
   [_ [_ bindings]]
   {:dispatch [:re-pressed.core/set-keydown-rules
               (make-keydown-rules bindings)]}))

(defn find-adjacent-segment
  [db item-id comparator]
  (let [segments (annotation-db/segments db item-id)
        current (get segments (annotation-db/current-segment-id db item-id))]
    (segment-model/find-adjacent-segment comparator segments current)))

#?(:cljs
   (defn play-segment
     [waveform {:keys [start end] :as segment}]
     (when segment
       (.play ^js waveform start end)
       nil)))

#?(:cljs
   (defn make-init-waveplayer
     [item-id waveform]

     ;; Jump to time T (in seconds) in the waveform.
     (rf/reg-event-fx
      :wave-player/set-time
      (fn set-time
        [_ [_ t]]
        (.setCurrentTime ^js waveform t)))

     (rf/reg-event-fx
      :wave-player/scrub-back
      (fn scrub-back
        [_ _]
        (.skipBackward ^js waveform)
        {}))
     (rf/reg-event-fx
      :wave-player/scrub-forward
      (fn scrub-forward
        [_ _]
        (.skipForward ^js waveform)
        {}))
     (rf/reg-event-fx
      :wave-player/play-prev-segment
      (fn play-prev-segment
        [{:keys [db]} _]
        (play-segment waveform (find-adjacent-segment db item-id <))))
     (rf/reg-event-fx
      :wave-player/play-next-segment
      (fn play-next-segment
        [{:keys [db]} _]
        (play-segment waveform (find-adjacent-segment db item-id >))))
     (rf/reg-event-fx
      :wave-player/play-current-segment
      (fn play-current-segment
        [{:keys [db]} _]
        (let [segment-id (annotation-db/current-segment-id db item-id)]
          (play-segment waveform (get (annotation-db/segments db item-id) segment-id)))))
     (rf/reg-event-fx
      :wave-player/play-last-sec-of-segment
      (fn play-last-sec-of-segment
        [{:keys [db]} _]
        (let [segment-id (annotation-db/current-segment-id db item-id)
              {:keys [start end]} (get (annotation-db/segments db item-id) segment-id)
              time (some-> end dec (max start))]
          (when time
            (.play ^js waveform time end)
            nil))))
     (rf/reg-event-fx
      :wave-player/go-back-to-end-of-prev-segment
      (fn go-back-to-end-of-prev-segment
        [{:keys [db]} _]
        (let [segments (annotation-db/segments db item-id)
              time (.getCurrentTime ^js waveform)
              segment-id (segment-model/find-prev-segment-id-by-end-time segments time)]
          (when segment-id
            (.pause ^js waveform)
            (wave-player/seek-and-centre waveform (:end (segments segment-id)))
            {:db (annotation-db/set-segment-id-to-select db item-id segment-id)}))))
     (rf/reg-event-fx
      ::init-waveplayer
      (fn init-waveplayer
        [_ [_ _]]
        {:dispatch [:re-pressed.core/set-keydown-rules
                    (make-keydown-rules [:annotation :wave-player])]}))
     (rf/dispatch [::init-waveplayer])))

(rf/reg-event-fx
 ::clear-keyboard
 (fn clear-keyboard
   [_ _]
   {:dispatch [:re-pressed.core/set-keydown-rules
               (make-keydown-rules [])]}))
